export const translate = (languageCode, entity = {}, field = 'Name', fallback = '', translationsField = 'translations') => {
    let result = fallback || entity[field.toLowerCase()];
    if (entity[translationsField]) {
        const all = JSON.parse(entity[translationsField]);
        const lang = all.find(x => x.Code === languageCode);
        if (lang) {
            result = lang[field] || result;
        }
    }

    return result || fallback;
};

export const translateCourse = (languageCode, c = {}) => {
    c.name = translate(languageCode, c, 'Title', c.name || c.title);
    c.description = translate(languageCode, c, 'Description', c.summary || c.description);
    return c;
};

export const translateArea = (languageCode, a = {}) => {
    a.name = translate(languageCode, a);
    return a;
};

export const translateCompetency = (languageCode, c = {}) => {
    const a = { name: c.area, translations: c.area_Translations };
    c.area = translate(languageCode, a);
    c.name = translate(languageCode, c);
    c.full_Name = `${c.area} - ${c.name}`;
    c.description = translate(languageCode, c, 'Description', c.description);
    return c;
};

export const translateOverride = (languageCode, c = {}) => {
    c.roleDescriptions?.forEach(entity => {
        entity.description = translate(languageCode, entity, 'Description', c.description);
    });

    return c;
};

export const translatePI = (languageCode, pi = {}) => {
    if (pi.ratingGroup) {
        pi.ratingGroup.option1 = translate(languageCode, pi.ratingGroup, 'Option_1', pi.ratingGroup.option1);
        pi.ratingGroup.option2 = translate(languageCode, pi.ratingGroup, 'Option_2', pi.ratingGroup.option2);
        pi.ratingGroup.option3 = translate(languageCode, pi.ratingGroup, 'Option_3', pi.ratingGroup.option3);
        pi.ratingGroup.option4 = translate(languageCode, pi.ratingGroup, 'Option_4', pi.ratingGroup.option4);
        pi.ratingGroup.option5 = translate(languageCode, pi.ratingGroup, 'Option_5', pi.ratingGroup.option5);
    }

    pi.statement = translate(languageCode, pi, 'Statement');
    return pi;
};

export const translateAppraisalJson = (languageCode, app = {}) => {
    app.competencies.map(c => translateCompetency(languageCode, c));
    return app;
};

export const systemTranslationTypes = {
    ratings: 'RATINGS_EXPLAINATION',
    reviewUser: 'REVIEW_USER',
    reviewManager: 'REVIEW_MANAGER',
    welcomeEmail: 'WELCOME_EMAIL',
};

export const translateSys = (languageCode, ref, settings, fallback) => {
    let defaultLanguage = '';
    switch (ref) {
        case systemTranslationTypes.ratings:
            defaultLanguage = settings.customText.ratingsExplaination;
            break;
        case systemTranslationTypes.reviewUser:
            defaultLanguage = settings.customText.reviewIntroUser;
            break;
        case systemTranslationTypes.reviewManager:
            defaultLanguage = settings.customText.reviewIntroManager;
            break;
        case systemTranslationTypes.welcomeEmail:
            defaultLanguage = settings.customText.introEmail;
            break;
        default:
            defaultLanguage = fallback;
    }

    const translations = JSON.parse(settings.translations || '[]');
    const language = translations?.find(x => x.code === languageCode && x.ref === ref);

    return language?.value || defaultLanguage || fallback;
};
